import React from 'react';
import styles from '../../../styles/DocumentManagement.module.css';
import AgentCompletionRow from './AgentCompletionRow';
import SkeletonLoader from './SkeletonLoader';
import { useManagerContext } from '../../../contexts/ManagerContext';

interface AgentCompletionStatusProps {
}

const AgentCompletionStatus: React.FC<AgentCompletionStatusProps> = () => {
  const { agencyUsers, loading, error } = useManagerContext();

  return (
    <div className={styles.documentManagementSection}>
      <h3>Agent Completion Status</h3>
      {loading ? (
        <SkeletonLoader variant="agentGrid" count={4} />
      ) : error ? (
        <div>Error: {error}</div>
      ) : !agencyUsers.length ? (
        <div>No agents found.</div>
      ) : (
        <div className={styles.agentGrid}>
          {agencyUsers.map(({ user, stats }) => (
            <AgentCompletionRow
              key={user.id}
              agent={user}
              agentStats={stats.overall}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AgentCompletionStatus;
